import React from "react";
import { TdSkeletonProps } from "../interfaces";

export const TdSkeleton: React.FC<TdSkeletonProps> = ({
  align = "left",
  firstFieldType = "text",
  isFirstFieldSubtitle,
  isSecondFieldSubtitle,
  minWidth = 100,
  secondFieldKey,
  secondFieldType = "text",
  weight = 1,
}) => {
  return (
    <td
      className={`flex flex-1 p-4 ${
        (secondFieldKey && secondFieldType !== "badge") ||
        firstFieldType === "redirect-to-sale"
          ? "flex-col gap-1"
          : ""
      } ${
        align === "right"
          ? "justify-end"
          : align === "center"
            ? "justify-center"
            : "justify-start"
      }`}
      style={{
        minWidth: `${minWidth}px`,
        flex: weight,
      }}
    >
      <div
        className={`animate-pulse bg-gray-200 ${
          firstFieldType === "boolean"
            ? `${isFirstFieldSubtitle ? "h-2 w-2" : "h-4 w-4"} rounded-full`
            : isFirstFieldSubtitle || firstFieldType === "session-counter"
              ? "h-3 w-3/5 rounded-md lg:w-1/3"
              : "h-4 w-full rounded-md lg:w-3/5"
        }`}
      />
      {((secondFieldKey && secondFieldType !== "badge") ||
        firstFieldType === "redirect-to-sale") && (
        <div
          className={`animate-pulse bg-gray-200 ${
            secondFieldType === "boolean"
              ? `${isSecondFieldSubtitle ? "h-2 w-2" : "h-4 w-4"} rounded-full`
              : isSecondFieldSubtitle ||
                  secondFieldType === "session-counter" ||
                  firstFieldType === "redirect-to-sale"
                ? "h-3 w-3/5 rounded-md lg:w-1/3"
                : "h-4 w-full rounded-md lg:w-3/5"
          }`}
        />
      )}
    </td>
  );
};
